<template>
  <div>
    <div class="page_container warehousingManagePage">
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manage' }"
            >SKU管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>库存管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="operation_wrap">
        <div class="flex-rowc filter_wrap">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入SKU编码/商品名称"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示库存列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
        <div class="txt">
          <p>Step-01 输入商品名称或SKU ID，查找目标商品；</p>
          <p>Step-02 获得查找结果后，可对商品库存进行管理；</p>
        </div>
      </div>
      <div class="main_container">
        <!-- <div class="operation_wrap flex-between">
          <div class="select_add flex-rowl"></div>
          <div class="filter flex-rowr">
            <div class="search_wrap flex-between">
              <el-input
                v-model="searchTxt"
                placeholder="输入SKU编码/商品名称"
                @keyup.enter.native="handleSearch()"
              ></el-input>
              <div class="search_btn flex-rowc" @click="handleSearch">
                <i class="iconfont icon-chazhaotubiao"></i>
              </div>
            </div>
          </div>
        </div> -->

        <!-- 主要内容 start -->
        <div
          class="list_wrap"
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.4)"
        >
          <template v-if="dataItem.length > 0">
            <div class="item_wrap" v-for="item in dataItem" :key="item.id">
              <div class="item_main_wrap flex-rowl">
                <div class="content_wrap flex-between">
                  <div class="pic_box">
                    <el-image :src="item.img" fit="contain">
                      <div slot="error" class="image-slot flex-rowc">
                        <i class="iconfont icon-zanwutupian1"></i>
                      </div>
                    </el-image>
                  </div>
                  <div class="intro_box flex-rowl">
                    <div class="block">
                      <h1>商品名称：</h1>
                      <p>
                        <span>{{ item.commodityname }}</span>
                      </p>
                      <p>
                        <span>{{ item.commodityname_e }}</span>
                      </p>
                      <p>
                        <span>{{ item.commodityname_y }}</span>
                      </p>
                      <p>
                        <span>{{ item.commodityname_m }}</span>
                      </p>
                      <p>
                        <span>{{ item.commodityname_t }}</span>
                      </p>
                    </div>
                    <div class="block">
                      <!-- <p>
                        商品ID：<span>{{ item.id }}</span>
                      </p> -->
                      <p>
                        SKU采购编码：<span>{{ item.sku }}</span>
                      </p>
                      <p>
                        品牌标签：<span>{{ item.brandname }}</span>
                      </p>
                      <p>
                        ISBN编码：<span>{{ item.ISBN }}</span>
                      </p>
                      <p>
                        商品所属企业：<span>{{
                          item.qyname ? item.qyname : item.qy_accountid
                        }}</span>
                      </p>
                      <p>
                        当前库存总量：<span>{{ item.kunum }}</span>
                      </p>
                      <!-- <p>
                        是否上架：<span>{{ item.commoditystate }}</span>
                      </p>
                      <p>
                        限购状态：<span v-if="item.islimit">{{
                          item.islimit == "不限购"
                            ? item.islimit
                            : "每人限购/" + item.limitnum + "件"
                        }}</span>
                      </p> -->
                    </div>
                    <div class="block"></div>
                    <div class="block">
                      <p>
                        添加日期：<span>{{
                          item.createdate | formatDate
                        }}</span>
                      </p>
                      <p>
                        操作人员：<span v-if="item.createman">{{
                          item.createman
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="edit_group flex-rowr">
                  <div class="editBtn" @click="handleGo(item.ISBN, item.id)">
                    库存管理
                  </div>
                </div>
              </div>
            </div>
          </template>
          <el-empty
            description="暂无数据"
            v-if="!loading && !dataItem.length > 0"
          ></el-empty>
        </div>
        <!-- 主要内容 end -->
      </div>
      <!-- <div class="primary-button" @click="handleSearch">查找</div>
      <div class="primary-button-plain" @click="handleToast">入库计划</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div> -->
      <!-- 分页 start -->
      <div class="pagination_wrap flex-rowc">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next, jumper"
          :page-size="10"
          :total="listTotal"
        >
        </el-pagination>
      </div>
      <!-- 分页 end -->
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  queryShop,
  getMenuAuthTwo,
  getMenuAuthThree,
  encryptstringadd,
} from "../../api/api";
export default {
  name: "wManageIndex",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      loading: false,
      dataItem: "",
      params: {
        keyword: "",
        openid: "",
        qyguid: "",
        pageindex: 1,
        pagesize: 10,
      },
      listTotal: 0,
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.roleId = this.$store.state.USERINFO.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.params.qyguid = this.$store.state.USERINFO.qy.qyguid;
    this.getMenuAuthTwo();
    this.getShop();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },
    // 获取按钮权限
    getMenuAuthThree() {
      let { menuItem } = this;
      getMenuAuthThree(menuItem.id).then((res) => {
        if (res.length == 0) return;
      });
    },

    handleToast() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$message.warning("即将开放");
      return;
    },

    handleReturn() {
      this.$router.go(-1);
    },

    handleSearch() {
      if (this.params.keyword == "") {
        this.$message.warning("请输入SKU编码/ISBN编码");
        return;
      } else {
        this.params.pageindex = 1;
        this.getShop();
      }
    },
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.getShop();
    },
    // 重置
    handleRest() {
      this.params.keyword = '' 
      this.params.pageindex = 1
       this.getShop()
    },
    getShop() {
      this.loading = true;
      queryShop(this.params).then((res) => {
        this.loading = false;
        this.dataItem = res.list;
        this.listTotal = res.total;
      });
    },

    handleGo(ISBN, id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$$message.warning("暂无权限");
        return;
      }

      this.encryptstringadd("wManageSettingList", { keyword: ISBN, cmid: id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingManagePage {
  // .input_box {
  //   margin-bottom: 117px;
  // }
  // .primary-button-plain {
  //   margin-top: 59px;
  // }
  .list_wrap {
    height: 51vh;
    margin-top: 30px;
    position: relative;
  }
  .operation_wrap {
    width: 550px;
    margin: 10px auto;
    // position: absolute;
    // left: 50%;
    // margin-top: 20px;
    // transform: translateX(-50%);
    .filter_wrap {
      margin-bottom: 10px;
    }
    .search_wrap {
      border: 1px solid #dcdfe6;
      border-radius: 44px;
      flex: 1;
      // margin-bottom: 10px;
      /deep/ .el-input__inner {
        border: none;
        border-radius: 45px;
      }
      .search_btn {
        width: 50px;
        cursor: pointer;
      }
    }
    .txt {
      color: red;
      font-size: 12px;
      p {
        margin-bottom: 5px;
      }
    }
  }
}
</style>